import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { getConfig } from 'helpers/appConfig';

const config = getConfig();

export const useStripe = () => {
  const startStripe = (stripeKey?: string) => loadStripe(stripeKey || config.stripeKey);

  return {
    startStripe,
  };
};
